import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall } from 'lucide-react';
export function FinalCTA() {
  return <section id="contacto" className="py-20 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-169">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-170">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold via-transparent to-transparent" data-id="element-171"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10 text-center" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-173">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-cream leading-tight" data-id="element-174">
            ¿Lista para hacer de tu celebración algo que tu familia recuerde
            toda la vida?
          </h2>

          <p className="text-xl text-gold font-medium" data-id="element-175">
            Da el primer paso hoy mismo.
          </p>

          <p className="text-lg text-cream/80 font-light max-w-2xl mx-auto" data-id="element-176">
            Llámanos o escríbenos — en español, con confianza, sin compromiso.
            Te contamos todo sobre nuestro servicio, verificamos la
            disponibilidad de tu fecha y te ayudamos a crear la experiencia
            perfecta para tu evento.
          </p>

          <div className="pt-8 pb-12" data-id="element-177">
            <div className="inline-block bg-gold text-ink font-bold px-8 py-3 rounded-full text-lg mb-8 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-178">
              CONTÁCTANOS AHORA
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto" data-id="element-179">
              <a href="tel:+14049409785" className="group flex flex-col items-center justify-center gap-3 bg-ink border border-gold/30 hover:border-gold p-8 rounded-2xl transition-all hover:-translate-y-1 hover:shadow-xl" data-id="element-180">
                <PhoneCall className="w-8 h-8 text-gold group-hover:scale-110 transition-transform" data-id="element-181" />
                <div className="text-sm text-cream/60 uppercase tracking-wider" data-id="element-182">
                  Línea Principal
                </div>
                <div className="text-2xl md:text-3xl font-bold text-cream group-hover:text-gold transition-colors" data-id="element-183">
                  (404) 940-9785
                </div>
              </a>

              <a href="tel:+16784721588" className="group flex flex-col items-center justify-center gap-3 bg-ink border border-gold/30 hover:border-gold p-8 rounded-2xl transition-all hover:-translate-y-1 hover:shadow-xl" data-id="element-184">
                <PhoneCall className="w-8 h-8 text-gold group-hover:scale-110 transition-transform" data-id="element-185" />
                <div className="text-sm text-cream/60 uppercase tracking-wider" data-id="element-186">
                  Línea Secundaria
                </div>
                <div className="text-2xl md:text-3xl font-bold text-cream group-hover:text-gold transition-colors" data-id="element-187">
                  (678) 472-1588
                </div>
              </a>
            </div>
          </div>

          <div className="pt-8 border-t border-gold/10" data-id="element-188">
            <p className="font-script text-3xl md:text-4xl text-gold" data-id="element-189">
              "Porque más que fotos… creamos recuerdos que se sienten, se
              comparten y se atesoran toda la vida."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}